// disabling this rule for now as we might the unused vars code in future
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';

import { Flex } from '@chakra-ui/react';

// import { Checkbox } from 'uiToolkitV1/Checkbox';
// import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyLarge } from 'uiToolkitV1/Typography';

import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from './Accordion';

// const SameViewSettingCheckbox = ({ settingSameAsFormId, onChangeHandler, firstViewName }) => (
//   <Flex alignItems="center">
//     <Checkbox isChecked={!!settingSameAsFormId} onChange={onChangeHandler} py={3}>
//       Use same settings as <b>{firstViewName}</b>
//     </Checkbox>
//     <TooltipInfoV1 title="todo" ml={3} />
//   </Flex>
// );

const MultiViewStepAccordionWrapper = ({
  firstViewName,
  feedbackFormName,
  index: viewIndex,
  settingSameAsFormId,
  onChangeHandler,
  children,
  isAllowSameSettingAsFirstView,
}) => {
  // TODO: v1 or later ->
  // const allowCustomSetting =
  //   viewIndex === 0 || !isAllowSameSettingAsFirstView || !!!settingSameAsFormId;
  const allowCustomSetting = true;
  const [userSelectedIndex, setUserSelectedIndex] = useState(viewIndex === 0 || allowCustomSetting ? 0 : null);

  return (
    <Accordion allowToggle index={allowCustomSetting ? userSelectedIndex : null}>
      <AccordionItem isDisabled={!allowCustomSetting}>
        {/* just another UX inconsistency, doing it for now! */}
        <AccordionButton
          _disabled={{
            '& button': { opacity: '1 !important' },
            '.toggle-svg': { opacity: '0.5 !important' },
          }}
          onClick={() => {
            setUserSelectedIndex((prevSelectedIndex) => (prevSelectedIndex === 0 ? null : 0));
          }}
        >
          <Flex justifyContent="space-between" flexGrow={1} alignItems="center">
            <TextBodyLarge bold>{feedbackFormName}</TextBodyLarge>
            <Flex>
              {/* TODO: as per product requirement not keeping in the first version as there are complexities around
              when to allow copy when to not */}
              {/* {viewIndex !== 0 && isAllowSameSettingAsFirstView && (
                <SameViewSettingCheckbox
                  onChangeHandler={onChangeHandler}
                  settingSameAsFormId={settingSameAsFormId}
                  firstViewName={firstViewName}
                />
              )} */}
            </Flex>
          </Flex>
        </AccordionButton>

        <AccordionPanel borderTop="0 !important">
          <Flex flexDirection="column" gap={3}>
            {children}
          </Flex>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export { MultiViewStepAccordionWrapper };
